import React from 'react';
import { Snackbar } from '@mui/material';
import { Alert } from '@mui/material';

function CustomAlert(props) {
    const { open, onClose, message, severity } = props;

    return (
        <Snackbar open={open} autoHideDuration={6000} onClose={onClose} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} style={{ zIndex: 1500, top:'100px' }}>
            <Alert onClose={onClose} severity={severity} sx={{ width: '100%' }} style={{ zIndex: 1500, top:'100px' }}>
                {message}
            </Alert>
        </Snackbar>
    );
}

export default CustomAlert;